export enum LogicGroupType {
  OR = "OR" as any,
  AND = "AND" as any,
}
